import React, { useRef } from "react";
import { FaMapMarkedAlt, FaRoute } from "react-icons/fa";

import useDismissOnOutsideClick from "../../components/Dashboard/useDismissOnOutsideClick";

const PRESETS = [
  { hours: 1, label: "Última 1 h" },
  { hours: 12, label: "Últimas 12 h" },
  { hours: 24, label: "Últimas 24 h" },
];

const WEEK_PRESET = { hours: 24 * 7, label: "Últimos 7 dias" };

function DashboardTracePanel({
  t,
  open,
  onToggle,
  onPresetHours,
  activePresetHours,
  traceLoading,
  traceError,
  machineCount,
  operatorCount,
  pointCount,
  selectedLandplots = [],
  onClearLandplots,
  landplotPickMode = false,
  onToggleLandplotPickMode,
}) {
  const rootRef = useRef(null);
  useDismissOnOutsideClick(open, rootRef, () => {
    if (open && typeof onToggle === "function") onToggle();
  });
  const fenceEnabled = selectedLandplots.length > 0;
  const presets = fenceEnabled ? PRESETS.concat(WEEK_PRESET) : PRESETS.concat({
    ...WEEK_PRESET,
    disabled: true,
  });
  return (
    <div className="map-trace-panel" ref={rootRef}>
      <button
        type="button"
        className={`btn-search map-trace-toggle${open ? " active" : ""}`}
        onClick={onToggle}
        title={t("Rastros das máquinas e operadores")}
      >
        <FaRoute />
        <span className="map-trace-toggle-label">{t("Rastros")}</span>
      </button>

      {open && (
        <div className="map-trace-content">
          <p className="map-trace-intro">
            {t(
              "Escolha talhão pelo ícone ou com dois cliques na cerca para filtrar o rastro."
            )}
          </p>

          <button
            type="button"
            className={`map-trace-pick${landplotPickMode ? " is-active" : ""}`}
            aria-pressed={Boolean(landplotPickMode)}
            onClick={() =>
              typeof onToggleLandplotPickMode === "function" &&
              onToggleLandplotPickMode()
            }
            title={t(
              "Escolher talhão: ligue e clique no mapa, ou dois cliques bem rápidos (até 300 ms) em qualquer ponto do talhão."
            )}
          >
            <FaMapMarkedAlt aria-hidden />
            <span>
              {landplotPickMode
                ? t("Clique no talhão no mapa")
                : t("Escolher talhão")}
            </span>
          </button>

          {fenceEnabled ? (
            <p className="map-trace-fence">
              {selectedLandplots.map((plot) => plot.name).join(", ")}
              {typeof onClearLandplots === "function" ? (
                <button type="button" onClick={onClearLandplots}>
                  {t("Limpar talhões")}
                </button>
              ) : null}
            </p>
          ) : (
            <p className="map-trace-fence map-trace-fence--empty">
              {landplotPickMode
                ? t("Modo ligado: clique no talhão.")
                : t("Nenhum talhão selecionado.")}
            </p>
          )}

          <div className="map-trace-presets">
            {presets.map((preset) => (
              <button
                key={preset.hours}
                type="button"
                className={
                  Number(activePresetHours) === preset.hours ? "is-active" : ""
                }
                onClick={() => onPresetHours(preset.hours)}
                disabled={traceLoading || preset.disabled}
                title={
                  preset.disabled
                    ? t("Selecione um ou mais talhões para liberar 7 dias")
                    : undefined
                }
              >
                {t(preset.label)}
              </button>
            ))}
          </div>

          {traceLoading && (
            <p className="map-trace-stats">{t("Carregando...")}</p>
          )}

          {traceError && (
            <p className="map-trace-error" role="alert">
              {traceError}
            </p>
          )}

          {!traceLoading && machineCount > 0 && (
            <p className="map-trace-stats">
              {t("{{count}} máquinas", { count: machineCount })}
              {operatorCount
                ? ` · ${t("{{count}} operadores", { count: operatorCount })}`
                : ""}{" "}
              · {t("{{count}} pontos no mapa", { count: pointCount })}
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default DashboardTracePanel;
